import {createAction} from '@ngrx/store';

export enum ParametryKwotyDocelowejActionTypes {
  WYCZYSC_PARAMETRY_KWOTY_DOCELOWEJ = '[ParametryKwotyDocelowej] wyczysc parametry kwoty docelowej',
}

export const wyczyscParametryKwotyDocelowej = createAction(
  ParametryKwotyDocelowejActionTypes.WYCZYSC_PARAMETRY_KWOTY_DOCELOWEJ
);
